// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__OMbVD","summary":"CartItem_summary__iROnr","price":"CartItem_price__NabAr","amount":"CartItem_amount__0BOV-","actions":"CartItem_actions__w0IXf"};